import type { ProductSurveyQuestion } from '@app/_proto/Protos/product_surveys';
import Checkbox from '@app/components/checkbox';
import { useMemo, useState } from 'react';

export type SurveyAnswerMultipleProps = {
    question: ProductSurveyQuestion;
    onAnswer: (questionId: string, answer: string) => void;
};

type QuestionData = {
    choices: string[] | undefined;
    allowMultipleSelection: boolean | undefined;
};

export default function SurveyAnswerMultiple({ question, onAnswer }: SurveyAnswerMultipleProps) {
    const questionData = useMemo(() => {
        const data: QuestionData = JSON.parse(question.data);
        return data;
    }, [question]);

    const [selectedChoices, setSelectedChoices] = useState<number[]>([]);

    const onCheckboxStateChange = (choice: number, checked: boolean) => {
        if (checked) {
            const newChoices = [...selectedChoices, choice];
            setAnswer(newChoices);
        } else {
            const newChoices = selectedChoices.filter(c => c !== choice);
            setAnswer(newChoices);
        }
    };

    const onRadioClicked = (choice: number) => {
        const newChoices = selectedChoices.find(c => c === choice) !== undefined ? [] : [choice];
        setAnswer(newChoices);
    };

    const setAnswer = (choices: number[]) => {
        setSelectedChoices(choices);

        if (choices.length === 0) {
            //Remove from answer list, if there are no choices selected
            onAnswer(question.id, '');
        } else {
            const newData = JSON.stringify({ choices: choices });
            onAnswer(question.id, newData);
        }
    };

    return (
        <>
            {questionData.choices?.map((choice, choiceIdx) => (
                <div key={`choice-${question.id}-${choiceIdx}`} className="flex items-center">
                    {questionData.allowMultipleSelection ? (
                        <Checkbox
                            variant="circle"
                            checked={selectedChoices.some(c => c === choiceIdx)}
                            onChange={checked => onCheckboxStateChange(choiceIdx, checked)}
                        />
                    ) : (
                        <input
                            id={`choice-${question.id}-${choiceIdx}`}
                            name={`choices-${question.id}`}
                            type="radio"
                            className="w-24 h-24 form-radio cursor-pointer checked:text-blue-600 bg-transparent checked:bg-none checked:p-6 checked:bg-clip-content border-none !ring-inset !ring-[1.5px] !ring-gray-assist !ring-offset-0"
                            value={choiceIdx}
                            checked={selectedChoices.some(c => c === choiceIdx)}
                            onClick={() => onRadioClicked(choiceIdx)}
                        />
                    )}
                    <label htmlFor={`choice-${question.id}-${choiceIdx}`} className="py-15 pl-8 grow font-normal">
                        {choice}
                    </label>
                </div>
            ))}
        </>
    );
}
